<template>
	<div>
		<Container>
			<TopBar />
			<div class="content">
				<div class='address transition_dom'>
					<template v-for='(address,index) in sortaddresse'>
						<div class="item" v-show='!isAllAddress?index<=3:true' :saa='index' :key="address.id" :class='{select:(address.id==qchoosedAddress.id),hover:(address.id==hoverActive)}' v-on:click.stop='chooseAddress(address)' @mouseenter='hoverActive=address.id' @mouseleave="hoverActive=-1">
							<div class="left">
								<span class="name">{{address.name}}</span>
								<span class="tel">{{address.moblie_phone}}</span>
								<Tag v-if="address.is_default" class="addressTag" color="#B176C5">帳戶預設地址&nbsp;&nbsp;Default Address</Tag>
								<p>
								<!-- <i v-if='IconText(address.tag_type)' :style="{color: iconColor(address.tag_type)}" v-text='IconText(address.tag_type)'></i> -->
								{{address.province}}&nbsp;&nbsp;{{address.city}}&nbsp;&nbsp; {{address.street}}&nbsp;&nbsp;{{address.street2}}&nbsp;&nbsp;{{address.email}}&nbsp;&nbsp;
								</p>
							</div>
							<div class="right" v-show='address.id==hoverActive' v-if="!isMobile">
								<img title="編輯地址" src="@/assets/edit.png" v-on:click.stop='modifyAddress(address)'>
								&nbsp;
								<img title="刪除地址" src="@/assets/del.png" v-on:click.stop='cdeleteAddress(address)'>
							</div>
							<div class="right" v-if="isMobile">
								<img title="編輯地址" src="@/assets/edit.png" v-on:click.stop='modifyAddress(address)'>
								&nbsp;
								<img title="刪除地址" src="@/assets/del.png" v-on:click.stop='cdeleteAddress(address)'>
							</div>
						</div>
					</template>
				</div>
				<span v-if='addresses.length > 4' class="showAllAddr" @click='operating'>{{isAllAddress?'收起地址':'顯示全部地址'}}&nbsp;<b>&gt;</b></span>
				<div class='addAddress'>
					<Button class="btn" type="primary" long @click='addAddress'><Icon type="md-add" size="16"/>添加收貨地址(Add New Delivery Address)</Button>
				</div>
			</div>
			<editAddressView :title="editAddress.id>0?'編輯地址(Edit address)':'新增地址(New address)'" :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='loading'></editAddressView>
		</Container>
		<transition mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import editAddressView from "@/components/order/editAddressView";
import util from "@/config/util";
import {cvoUrl} from '@/config/env'
import { api_methods } from "@/service/loadData";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import {
	addressMethods,
} from "@/components/common/mixin";
export default {
	data() {
		return {
			isAllAddress: false,
			addresses: [],
			hoverActive: -1,
		};
	},
	created() {
		this.$nextTick(function() {
			this.initData();
		});
	},
	mounted() {},
	watch: {
		addresses: function (value, ovalue) {
			if (ovalue && ovalue.length > 0) {
				var change = value.filter(
					(u) => u.id == this.qchoosedAddress.id
				);
				if (change[0]) {
					this.CHOOSE_ADDRESS({
						address: change[0],
						index: 0,
					});
				}
			}
		},
	},
	mixins: [
		addressMethods,
	],
	components: {
		TopBar,
		editAddressView,
	},
	computed: {
		...mapGetters([
        ]),
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			token: state => state.common.userToken,
		}),
		sortaddresse: function () {
			console.log(this.addresses)
			return this.addresses.sort(function (a, b) {
				return b.is_default - a.is_default;
			});
		},
		qchoosedAddress: function () {
			return this.choosedAddress || {};
		},
		isMobile() {
			if (document.body.clientWidth <= 768) {
				return true;
			}
			return false;
		},
	},
	methods: {
		...mapMutations([
			"CHOOSE_ADDRESS",
        ]),
		...mapActions([
			'postAddAddressAction','delAddressAction','getWechatUserInfoAction'
		]),
		timeComparison(str, str1) {
			var valid_from = !str ? null : util.formatDate.dateFromStr(str);
			var valid_to = !str1 ? null : util.formatDate.dateFromStr(str1);
			var now = new Date();
			return (
				(valid_from <= now || !valid_from) &&
				(valid_to >= now || !valid_to)
			);
		},
        async initData(){
			console.log(this.userInfo)
			this.addresses = this.userInfo.value && (this.userInfo.value.binding.address || []);
        },
		chooseAddress: function (address) {
			this.CHOOSE_ADDRESS({ address, index: 0 });
		},
		cdeleteAddress(address) {
			let vm = this;
			// if (address.address_type == 0) {
			// 	this.$Modal.error({
			// 		title: "錯誤 (error)",
			// 		content: "註冊地址不可刪除哦",
			// 	});
			// 	return;
			// }
			this.deleteAddress(address).then((res) => {
				if (vm.qchoosedAddress.id == address.id) {
					vm.CHOOSE_ADDRESS({
						address: null,
						index: 0,
					});
				}
			});
		},
        async operating(){
			this.isAllAddress = !this.isAllAddress;
        },
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.content {
	padding-top: 10px;
	width: 80%;
	margin: auto;
	list-style: none;
	margin-bottom: 50px;
	.showAllAddr {
		color: $theme-color;
		font-weight: 500;
		border-bottom: 1px solid #fff;
		display: block;
		cursor: pointer;
		@include fontSize($font-size-14);
		// margin-bottom: 20px;
	}
}
.address {
	@include fontSize($font-size-15);
	overflow: hidden;
	.item {
		cursor: pointer;
		width: 100%;
		border: 1px solid #eee;
		padding: 20px;
		overflow: hidden;
		margin-bottom: 15px;
		&.select {
			border-color: $theme-color;
			border-width: 2px;
			&.hover {
				border-width: 2px;
			}
		}
		&.hover {
			border-color: $theme-color;
			border-width: 1px;
		}
		.left {
			float: left;
			i {
				display: inline-block;
				font-style: normal;
				@include fontSize($font-size-13);
				color: #fff;
				margin-right: 3px;
			}
		}
		.right {
			float: right;
			position: relative;
			top: 20px;
			img {
				width: 15px;
			}
		}
		.name {
		}
		.tel {
			margin-left: 20px;
			margin-right: 10px;
		}
		p {
			padding-top: 3px;
		}
	}
}
.transition_dom {
	transition: all 0.3s linear 0s;
}
.addAddress{
	width: 30%;
	height: 45px;
	margin-left: auto;
	margin-right: auto;
	.btn{
		width: 100%;
		height: 100%;
		text-align: center;
	}
}
@media screen and (max-width: 768px) {
	.addAddress{
		width: 100%;
	}
}
</style>